// extracted by mini-css-extract-plugin
export default {"wrapper":"PageAdmin_wrapper__CYDsI"};